/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsorderpending2Inputs */

const en_ticketsorderpending2 = /** @type {(inputs: Ticketsorderpending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_ticketsorderpending2 = /** @type {(inputs: Ticketsorderpending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Ticketsorderpending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsorderpending2 = /** @type {((inputs?: Ticketsorderpending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsorderpending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsorderpending2(inputs)
	return de_ticketsorderpending2(inputs)
});
export { ticketsorderpending2 as "ticketsOrderPending" }